module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-1",
    attrs: {
      "id": "untitled-1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-111"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("The Trail of Ted Bundy published by:")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("WILDBLUE PRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override2"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("1153 Bergen Pkwy Ste I #114"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n      Evergreen, Colorado 80439"), _c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Copyright 2016 by Kevin Sullivan")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any means without the prior written consent of the Publisher, excepting brief quotes used in reviews.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("WILDBLUE PRESS is registered at the U.S. Patent and Trademark Offices.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("978-1-942266-37-2  Trade Paperback ISBN")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("978-1-942266-38-9  eBook ISBN")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Cover photograph Courtesy of the Salt Lake Tribune"), _c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Book Cover and Interior Formatting by Elijah Toten")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("www.totencreative.com")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2303bbc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 63
// module chunks = 0